import {
  RequirementLevel1Policy,
  RequirementLevel2Policy,
  RequirementLevel3Policy,
  RequirementLevel4Policy,
} from "@design-controls/types";
import i18n from "../i18n/config";

type RequirementConfiguration = {
  req1: RequirementLevel1Policy;
  req2: RequirementLevel2Policy;
  req3: RequirementLevel3Policy;
  req4: RequirementLevel4Policy;
};

export const INITIAL_REQUIREMENT_CONFIGURATION: RequirementConfiguration = {
  req1: {
    codePrefix: i18n.t("requirements.initialConfiguration.req1.codePrefix"),
    label: i18n.t("requirements.initialConfiguration.req1.label"),
    codeStrategy: "GENERATED",
    type: "req1",
  },
  req2: {
    codePrefix: i18n.t("requirements.initialConfiguration.req2.codePrefix"),
    label: i18n.t("requirements.initialConfiguration.req2.label"),
    codeStrategy: "GENERATED",
    type: "req2",
  },
  req3: {
    codePrefix: i18n.t("requirements.initialConfiguration.req3.codePrefix"),
    label: i18n.t("requirements.initialConfiguration.req3.label"),
    codeStrategy: "GENERATED",
    type: "req3",
  },
  req4: {
    codePrefix: "",
    label: "",
    codeStrategy: "GENERATED",
    type: "req4",
  },
} as const;
